export default {
  date: 'October 9, 2023',
  title: '3 uses of AI in real estate',
  description: "When you think of artificial intelligence (AI) in real estate, you probably don't think of it",
  id: '3-uses-of-ai-in-real-estate',
  jsx: () => (
    <div class='novelty__text'>
      <p>When you think of artificial intelligence (AI) in real estate, you probably don't think of it. However, like much of the business world, the real estate industry is embracing the power of artificial intelligence (AI).</p>
      <p>1. One common application of AI in real estate is predictive analytics, used for real estate valuation and predicting market trends.</p>
      <p>2. 3D modeling and "digital twins" allow users to explore properties digitally, increasing potential buyers and saving time and money.</p>
      <p>3. AI aids in property management, from tenant screening with chatbots to payment processing and reporting for improved efficiency.</p>
      <p>
        Will AI change the world of real estate?
        <br />
        Real estate is a massive, fragmented industry that is typically slow to change, but the examples above show that AI is already having an impact in areas like predictive analytics, property estimates, smart home devices, mortgages, and others.
      </p>
    </div>
  ),
  thumb: 'news/4.webp',
};
